export default {
  count (state, getters, rootState) {
    return state.countData
  },
  recent (state, getters, rootState) {
    return state.recentEntities
  }
}



// WEBPACK FOOTER //
// ./src/modules/stats/store/getters.js